import React from 'react'
import { StandardColumn } from '../../../../components/StandardPage'
import { OverflowCell } from '../../../../components/OverflowCell'

export const collectionsScreenKey = 'collections'

export interface CollectionRow {
  id: number
  collectionName: string
  brand?: string
  collectionColor: string
  families: string
  grades: string
  groups: string
  fabrics: string
  trimmings: string
  episodes: string
}

const getFirstWithEllipsis = (content: string): string => {
  if (!content) return '-'
  const parts = content.split(',').map((s) => s.trim()).filter(Boolean)
  if (parts.length === 0) return '-'
  if (parts.length === 1) return parts[0]
  return `${parts[0]}...`
}

const buildTooltipText = (content: string): string => {
  if (!content) return ''
  const items = content.split(',').map((s) => s.trim()).filter(Boolean)
  return items.length > 1 ? items.join('\n') : content
}

const summarizedCell = (value: string) => (
  <OverflowCell text={buildTooltipText(value)} forceTooltip={value?.includes(',')}>
    {getFirstWithEllipsis(value)}
  </OverflowCell>
)

export const buildCollectionColumns = (): StandardColumn<CollectionRow>[] => [
  {
    id: 'collectionName',
    label: 'Coleção',
    cell: (collection) => (
      <OverflowCell
        text={buildTooltipText(collection.collectionName)}
        forceTooltip={collection.collectionName?.includes(',')}
      >
        {collection.collectionName}
      </OverflowCell>
    ),
  },
  {
    id: 'brand',
    label: 'Marca',
    cell: (collection) => (
      <OverflowCell
        text={collection.brand || '-'}
        forceTooltip={Boolean(collection.brand && collection.brand.length > 20)}
      >
        {collection.brand || '-'}
      </OverflowCell>
    ),
  },
  { id: 'collectionColor', label: 'Cor', cell: (collection) => summarizedCell(collection.collectionColor) },
  { id: 'families', label: 'Famílias', cell: (collection) => summarizedCell(collection.families) },
  { id: 'grades', label: 'Grades', cell: (collection) => summarizedCell(collection.grades) },
  { id: 'groups', label: 'Grupos', cell: (collection) => summarizedCell(collection.groups) },
  { id: 'episodes', label: 'Episódios', cell: (collection) => summarizedCell(collection.episodes) },
  { id: 'fabrics', label: 'Tecidos', cell: (collection) => summarizedCell(collection.fabrics) },
  { id: 'trimmings', label: 'Aviamentos', cell: (collection) => summarizedCell(collection.trimmings) },
]
